import GrayHeaderCard from "../../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {Typography} from "@material-ui/core";
import React from "react";
import TokenOptionsTable
    from "../../../../../../../../../../shared/components/tables/token-options-table/TokenOptionsTable";
import {useSelector} from "react-redux";
import {Skeleton} from "@material-ui/lab";
import {getRandomNumber} from "../../../../../../../../../../shared/utils/utils";

const OpzioniGettoniCard = () => {
    const currentOfferLoading = useSelector(state => state.contrattoDigitaleReducer.currentOffer.loading)
    const opzioniGettoni = useSelector(state => state.contrattoDigitaleReducer.currentOffer.data.opzioniGettoniDtoList)

    return (
        <GrayHeaderCard title={
            <Typography variant="subtitle2">
                Opzioni e gettoni compatibili
            </Typography>
        }>
            {currentOfferLoading ?
                <Skeleton variant='rect' height={`${getRandomNumber(250, 400)}px`} animation='pulse'/> :
                <TokenOptionsTable data={opzioniGettoni}/>}
        </GrayHeaderCard>
    )
}

export default OpzioniGettoniCard
